import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/external-data/import-hub')({
  async beforeLoad({ context }) {
    const isExternalDataFeature = await context.isFlagEnabled(
      '@myn/secured',
      'externalDataFeature',
    );
    if (!isExternalDataFeature) {
      throw notFound();
    }

    const hasViewPermission = await context.hasPermission(
      'dataManagementHubFeature:view',
    );
    if (!hasViewPermission) {
      throw notFound();
    }
  },
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/import-hub');
    const title = i18n.t('Import Hub | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
